<template>
    <div>
        <ul
            class="flex-0"
        >
            <li
                v-for="property in properties.filter(x => x.type === 'checkbox')"
                :key="property.name"
            >
                <v-checkbox
                    v-model="propSelected[property.name]"
                    :label="property.label"
                    hide-details
                ></v-checkbox>
            </li>
        </ul>

        <ul
            class="flex-0"
        >
            <li
                v-for="property in properties.filter(x => x.type === 'text')"
                :key="property.name"
            >
                <v-text-field
                    :label="property.label"
                    v-model="propSelected[property.name]"
                >
                </v-text-field>
            </li>
        </ul>
        <ul
            class="flex-0"
        >
            <li
                v-for="property in properties.filter(x => x.type === 'select')"
                :key="property.name"
            >
                <v-select
                    v-model="propSelected[property.name]"
                    :items="property.items"
                    item-text="label"
                    item-value="value"
                    :label="property.label"
                    multiple
                >
                </v-select>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'TeacherContactOptions',
    props: {
        propValue: {
          type: Object,
          default() {
              return {};
          },
        },
    },
    data() {
        return {
            properties: [],
            propSelected: (this.propValue) ? this.propValue : {},
        };
    },
    created() {
        this.properties = this.getTeacherContacts();
    },
    watch: {
        propSelected: {
            deep: true,
            immediate: true,
            handler(val) {
               this.$emit('propertySelected', val);
            },
        },
    },
};
</script>
<style lang="scss">
    .flex-0 {
        display: flex;
        flex-wrap: wrap;
        li {
            list-style-type: none;
            padding-left: 10px;
        }
    }
</style>
